<template>
  <section class="grid-flex column w100">
    <div id="line-bar" class="flex w100 row ">
      <div
        v-for="(k, index) in listRender"
        :key="index"
        :style="`width: ${getValue(k)}%; background:${getColor(index)}`"
      >
        <div
          class="my-bar"
          :style="`width: ${getValue(k)}%; background:${getColor(index)}`"
        ></div>
      </div>
    </div>
    <div class="flex w100 center  margin-top-l">
      <div v-for="(k, index) in listRender" :key="index">
        <span
          style="display: inline-block; min-width: 14px; min-height: 14px;"
          :style="`background:${getColor(index)}`"
        ></span>
        <span class="label"> {{ k }} ({{ getValue(k) | number }}%) </span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "custom-line",
  props: ["data", "colors"],
  data() {
    return {};
  },
  computed: {
    listRender() {
      return Object.keys(this.data);
    },
  },
  mounted() {},
  methods: {
    getValue(key) {
      if (!this.data) {
        return "0";
      }
      let value = this.data[key];

      if (!value) {
        return "0";
      }

      return value;
    },
    getColor(index) {
      let auxColor = [
        "#47265a",
        "#c2c2c2",
        "rgb(104, 213, 136)",
        "rgb(166, 171, 176)",
      ];

      if (!this.colors) {
        return auxColor[index];
      }

      return this.colors[index]
    },
  },
};
</script>

<style lang="scss">
.my-bar {
  height: 20px;
}
.label {
  margin-right: 12px;
}
#line-bar {
  background: #c2c2c25c;
}
</style>
